const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function fmtMoney(value) {
  const num = parseFloat(value);
  return isNaN(num) ? '—' : fmt.format(num);
}
